module.exports = __webpack_public_path__ + "static/media/sky-bg.b7b4b195.jpg";